<template>
    <div :class="styleClass">
        <a href="#" @click.prevent="click" class="item item_bottom" :data-teaser="teaser.data" :data-id="teaser.teaser_id" :data-position="teaser.position" :data-index="teaser.index" :style="style">
            <div class="container__wrapper">
                <div class="container__content">
                    <div class="card_col_1 news-teasernews-teaser">
                        <div v-html="getImage"></div>
                        
                        <div class="item__gradient"  :style="gradientStyle"></div>
                    </div>
                    <div class="card-img-out">
                        <h5 class="card-title">{{teaser.title}}</h5>
                        <div class="card-description"v-if="teaser.description && teaser.description.length > 0">{{teaser.description}}</div>
                    </div>
                </div>
            </div>

        </a>
    </div>
</template>

<script>
    import FastAverageColor from 'fast-average-color';
    export default {
        name: "news-teaser",

        props:{
            styleClass:String,
            teaser:Object,
            square:{
                type:Boolean,
                default:false,
            },
            position:{
                type:Number,
                default:0,
            },
        },
        data(){
            return {
                gradientStyle:{},
                style:{},
                size: 50,
            }
        },
        mounted() {
            // window.fac();
            
            
            this.style = {
                background: 'rgb(17, 12, 9)',
                color:      'white',
            };

            this.gradientStyle  = {background: 'linear-gradient(rgba(17, 12, 9, 0) 0%, rgb(17, 12, 9) 100%)'};

            
//             let img = this.$refs.img;
//             let vue = this;
            
//                 img.addEventListener('load', function()
//                 {

//                     if (vue.teaser.is_rtb == 1) return;

//                     let fac = new FastAverageColor();
//                     let height = this.naturalHeight;

//                     let color = fac.getColor(this, {top: height - vue.size, height: vue.size});

//                     var colorEnd = [].concat(color.value.slice(0, 3), 0).join(',');
//                     vue.style = {
//                         background: color.rgb,
//                         color:      color.isDark ? 'white' : 'black',
//                     };

//                     vue.gradientStyle  = {background: 'linear-gradient(to bottom, ' +
//                             'rgba(' + colorEnd + ') 0%, ' + color.rgba + ' 100%)'};
//                 }, false)
           
			
        },
        methods:{
            click() {
                //this.teaser.position = this.position;
                this.Helper.adClick(this, this.teaser, true);
            },
             getGradientStyle(teaserImgs){
                return {background: 'linear-gradient(to bottom, ' +
                        'rgba(' + teaserImgs.colorEnd + ') 0%, ' + teaserImgs.color.rgba + ' 100%)'};
            }
        },
         computed: {
             getImage() {
                 if (!this.teaser.path_rectangle_image ) return;
                 if (window.teaserImgs[this.teaser.path_rectangle_image]) {
                     this.style = window.teaserImgs[this.teaser.path_rectangle_image].style;
                     this.gradientStyle = this.getGradientStyle(window.teaserImgs[this.teaser.path_rectangle_image]);
                     let img = window.teaserImgs[this.teaser.path_rectangle_image].img;
                     return img.outerHTML;
                 }
                 
                 
                let img = new Image();
				img.src = this.teaser.path_rectangle_image;               
				
                 
                 if (this.teaser.is_rtb == 0) {
                    img.crossOrigin = 'Anonymous';                     
               } 
                 
//                  	return `<img :src="teaser.path_rectangle_image" ref="img" class="card-img" v-bind="crossorigin" >`
                 img.classList.add('card-img');
//                  img.addClass('card-img');
                  let vue = this;
                 
                  img.addEventListener('load', function()
                {

                    if (vue.teaser.is_rtb == 1) return;

                    let fac = new FastAverageColor();
                    let height = this.naturalHeight;

                    let color = fac.getColor(this, {top: height - vue.size, height: vue.size});

                    var colorEnd = [].concat(color.value.slice(0, 3), 0).join(',');
                    vue.style = {
                        background: color.rgb,
                        color:      color.isDark ? 'white' : 'black',
                    };

//                     vue.gradientStyle  = {background: 'linear-gradient(to bottom, ' +
//                             'rgba(' + colorEnd + ') 0%, ' + color.rgba + ' 100%)'};

                     window.teaserImgs[vue.teaser.path_rectangle_image] = {
                         img:this,
                         style: {
                            background: color.rgb,
                            color:      color.isDark ? 'white' : 'black',
                    		},
                        color,
                         colorEnd
                     };
                      
                 vue.gradientStyle  = vue.getGradientStyle(window.teaserImgs[vue.teaser.path_rectangle_image]);
                      
                }, false)
                 
                 return img.outerHTML;
				
             },
              crossorigin(){   
                  
               if (this.teaser.is_rtb == 0) {
                   return {crossorigin:'anonymous'};
               } 
                
                return {};
            }
        }

    }
</script>

<style scoped>

</style>